(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('[data-accordion-item]');

    accordionItems.forEach((item) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const content = item.querySelector('[data-accordion-content]');

      if (trigger && content) {
        trigger.addEventListener('click', function () {
          const isOpen = item.getAttribute('data-accordion-open') === 'true';

          // Close all other accordion items
          accordionItems.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.setAttribute('data-accordion-open', 'false');
              otherItem.querySelector('[data-accordion-content]').classList.remove('open');
            }
          });

          // Toggle current item
          if (isOpen) {
            item.setAttribute('data-accordion-open', 'false');
            content.classList.remove('open');
          } else {
            item.setAttribute('data-accordion-open', 'true');
            content.classList.add('open');
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-remove-function"] && !Shopify.designMode) return;
  try {
    function removeCartItem(itemKey) {
    // First, get the current cart to check if this is a bundle item
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        // Find the item being removed
        const itemToRemove = cart.items.find((item) => item.key === itemKey);

        if (itemToRemove && itemToRemove.properties && itemToRemove.properties['Bundle Group']) {
          // This is a bundle item - remove all items in the same bundle
          const bundleId = itemToRemove.properties['Bundle Group'];
          const itemsToRemove = cart.items.filter(
            (item) => item.properties && item.properties['Bundle Group'] === bundleId
          );

          // Remove all items in the bundle
          const removePromises = itemsToRemove.map((item) =>
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0,
              }),
            })
          );

          return Promise.all(removePromises);
        } else {
          // Regular item - remove normally
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: 0,
            }),
          });
        }
      })
      .then((response) => {
        // Handle response - could be single response or array of responses
        const responses = Array.isArray(response) ? response : [response];
        return Promise.all(responses.map((r) => r.json()));
      })
      .then((data) => {
        // Update cart UI after successful removal
        if (typeof window.updateCartUI === 'function') {
          window.updateCartUI();
          // Note: openCartDropdown is already called within updateCartUI
        } else {
          // Fallback to page reload if updateCartUI is not available
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error('Error removing item from cart:', error);
      });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["counter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const counterContainers = document.querySelectorAll('.counter-container');

    counterContainers.forEach((container) => {
      const input = container.querySelector('.counter-input');
      const plusBtn = container.querySelector('.counter-btn--plus');
      const minusBtn = container.querySelector('.counter-btn--minus');

      if (!input || !plusBtn || !minusBtn) return;

      const min = parseInt(input.getAttribute('min')) || 1;
      const max = parseInt(input.getAttribute('max')) || 99;

      function updateButtons() {
        // Don't update if disabled via prop
        if (container.hasAttribute('data-prop-disabled')) {
          return;
        }
        const value = parseInt(input.value) || min;
        minusBtn.disabled = value <= min;
        plusBtn.disabled = value >= max;
      }

      plusBtn.addEventListener('click', function () {
        // Don't process if disabled via prop or button is disabled
        if (container.hasAttribute('data-prop-disabled') || this.disabled) {
          return;
        }
        const currentValue = parseInt(input.value) || min;
        if (currentValue < max) {
          input.value = currentValue + 1;
          updateButtons();
        }
      });

      minusBtn.addEventListener('click', function () {
        // Don't process if disabled via prop or button is disabled
        if (container.hasAttribute('data-prop-disabled') || this.disabled) {
          return;
        }
        const currentValue = parseInt(input.value) || min;
        if (currentValue > min) {
          input.value = currentValue - 1;
          updateButtons();
        }
      });

      // Initialize button states
      updateButtons();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dropdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Initialize all dropdowns
    const dropdowns = document.querySelectorAll('[data-dropdown]');

    dropdowns.forEach(function (dropdown) {
      const trigger = dropdown.querySelector('.dropdown-trigger');
      const content = dropdown.querySelector('.dropdown-content');

      if (!trigger || !content) return;

      // Toggle dropdown on click
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = dropdown.getAttribute('data-open') === 'true';

        // Close all other dropdowns first
        document.querySelectorAll('[data-dropdown]').forEach(function (otherDropdown) {
          if (otherDropdown !== dropdown) {
            otherDropdown.setAttribute('data-open', 'false');
            otherDropdown.querySelector('.dropdown-trigger').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current dropdown
        if (isOpen) {
          dropdown.setAttribute('data-open', 'false');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          dropdown.setAttribute('data-open', 'true');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      // Open dropdown on hover
      dropdown.addEventListener('mouseenter', function () {
        // Close all other dropdowns first
        document.querySelectorAll('[data-dropdown]').forEach(function (otherDropdown) {
          if (otherDropdown !== dropdown) {
            otherDropdown.setAttribute('data-open', 'false');
            otherDropdown.querySelector('.dropdown-trigger').setAttribute('aria-expanded', 'false');
          }
        });

        // Open current dropdown
        dropdown.setAttribute('data-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
      });

      // Close dropdown when mouse leaves
      dropdown.addEventListener('mouseleave', function () {
        dropdown.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          dropdown.setAttribute('data-open', 'false');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });

      // Close dropdown on escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && dropdown.getAttribute('data-open') === 'true') {
          dropdown.setAttribute('data-open', 'false');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay"] && !Shopify.designMode) return;
  try {
    // Global overlay functions
  window.openOverlay = function (overlayId) {
    const overlay = document.getElementById(overlayId);

    if (overlay) {
      overlay.style.display = 'block';

      // Add overlay-open class to body to hide header and spacer
      document.body.classList.add('overlay-open');

      // Prevent background scrolling on desktop only
      if (window.innerWidth >= 768) {
        document.body.style.overflow = 'hidden';
      }

      // Focus trap for accessibility
      const focusableElements = overlay.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    } else {
      console.error('Overlay element not found with ID:', overlayId);
    }
  };

  window.closeOverlay = function (overlayId) {
    const overlay = document.getElementById(overlayId);
    if (overlay) {
      overlay.style.display = 'none';

      // Remove overlay-open class from body to show header and spacer
      document.body.classList.remove('overlay-open');

      // Restore scrolling
      document.body.style.overflow = '';
    }
  };

  // Close overlay when clicking outside content area
  document.addEventListener('click', function (event) {
    const overlay = event.target.closest('.overlay');
    const overlayContent = event.target.closest('.overlay-content');

    if (overlay && !overlayContent) {
      const overlayId = overlay.id;
      closeOverlay(overlayId);
    }
  });

  // Close overlay with Escape key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      const openOverlays = document.querySelectorAll(
        '.overlay[style*="display: block"], .overlay:not([style*="display: none"])'
      );
      openOverlays.forEach((overlay) => {
        if (overlay.style.display === 'block' || overlay.style.display !== 'none') {
          closeOverlay(overlay.id);
        }
      });
    }
  });

  // Handle window resize to adjust scroll behavior
  window.addEventListener('resize', function () {
    const openOverlays = document.querySelectorAll('.overlay[style*="display: block"]');
    openOverlays.forEach(function (overlay) {
      if (window.innerWidth >= 768) {
        // Desktop: prevent background scrolling
        document.body.style.overflow = 'hidden';
      } else {
        // Mobile: allow scrolling
        document.body.style.overflow = '';
      }
    });
  });

  // Initialize event listeners on page load
  document.addEventListener('DOMContentLoaded', function () {
    // Add event listener for customize button
    const customizeBtn = document.getElementById('customize-build-a-drip-btn');
    if (customizeBtn) {
      customizeBtn.addEventListener('click', function () {
        openOverlay('build-a-drip-overlay');
      });
    }

    // Auto-open build-a-drip overlay if URL params are present
    const urlParams = new URLSearchParams(window.location.search);
    const hasBeadParam = urlParams.has('bead');
    const hasCarabinerParam = urlParams.has('carabiner');
    const hasCharmParam = urlParams.has('charm');

    // If any build-a-drip params exist, auto-open the overlay
    if (hasBeadParam || hasCarabinerParam || hasCharmParam) {
      const buildADripOverlay = document.getElementById('build-a-drip-overlay');
      if (buildADripOverlay) {
        // Small delay to ensure the page and configurator are fully loaded
        setTimeout(function () {
          openOverlay('build-a-drip-overlay');
        }, 500);
      }
    }

    // Add event listeners for all overlay close buttons
    document.querySelectorAll('.overlay-close-btn').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const overlay = this.closest('.overlay');
        if (overlay) {
          closeOverlay(overlay.id);
        }
        return false;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.product-carousel');

    // Check if desktop
    function isDesktop() {
      return window.innerWidth >= 768;
    }

    function isSafariBrowser() {
      var ua = navigator.userAgent || '';
      var vendor = navigator.vendor || '';
      var isAppleVendor = vendor.indexOf('Apple') > -1;
      var isSafariUA = /safari/i.test(ua) && !/chrome|crios|chromium|edg/i.test(ua);
      return isAppleVendor || isSafariUA;
    }

    carousels.forEach(function (carousel) {
      const thumbnails = carousel.querySelectorAll('.carousel-thumbnail');
      const imageWrappers = carousel.querySelectorAll('.carousel-image-wrapper');
      const videoWrappers = carousel.querySelectorAll('.carousel-video-wrapper');
      const productVideoWrappers = carousel.querySelectorAll('.carousel-product-video');
      const mediaWrappers = carousel.querySelectorAll('.carousel-image-wrapper, .carousel-video-wrapper');

      if (thumbnails.length === 0 || mediaWrappers.length === 0) return;

      // Pause all product videos
      function pauseAllProductVideos() {
        productVideoWrappers.forEach(function (wrapper) {
          const video = wrapper.querySelector('.carousel-product-video-player');
          if (video) {
            video.pause();
          }
        });
      }

      // Pause all animated videos
      function pauseAllAnimatedVideos() {
        videoWrappers.forEach(function (wrapper) {
          if (!wrapper.classList.contains('carousel-product-video')) {
            const video = wrapper.querySelector('.carousel-main-video');
            if (video) {
              video.pause();
            }
          }
        });
      }

      // Load appropriate videos based on device
      function loadVideosForDevice() {
        const desktop = isDesktop();
        const deviceType = desktop ? 'desktop' : 'mobile';
        const safari = isSafariBrowser();

        // Load main videos for current device only
        const deviceVideoWrappers = carousel.querySelectorAll(`.carousel-video-wrapper[data-device="${deviceType}"]`);
        deviceVideoWrappers.forEach(function (videoWrapper) {
          const video = videoWrapper.querySelector('.carousel-main-video');
          if (video && !video.querySelector('source')) {
            var webmSrc = video.dataset.videoSrcWebm;
            var movSrc = video.dataset.videoSrcMov;
            var chosenSrc = null;
            var chosenType = null;

            if (deviceType === 'desktop') {
              if (safari && movSrc) {
                chosenSrc = movSrc;
                chosenType = 'video/quicktime; codecs=hvc1';
              } else if (webmSrc) {
                chosenSrc = webmSrc;
                chosenType = 'video/webm; codecs=vp9, opus';
              } else if (movSrc) {
                chosenSrc = movSrc;
                chosenType = 'video/quicktime; codecs=hvc1';
              }
            } else {
              if (movSrc) {
                chosenSrc = movSrc;
                chosenType = 'video/quicktime; codecs=hvc1';
              } else if (webmSrc) {
                chosenSrc = webmSrc;
                chosenType = 'video/webm; codecs=vp9, opus';
              }
            }

            if (chosenSrc) {
              const source = document.createElement('source');
              source.src = chosenSrc;
              if (chosenType) source.type = chosenType;
              video.appendChild(source);
              video.load();
            }

            // Start playing if active
            if (videoWrapper.classList.contains('active')) {
              video.play();
            }
          }
        });

        // Load thumbnail videos for current device only
        const deviceThumbVideos = carousel.querySelectorAll(`.carousel-thumb-video[data-device="${deviceType}"]`);
        deviceThumbVideos.forEach(function (video) {
          if (!video.querySelector('source')) {
            var webmSrc = video.dataset.videoSrcWebm;
            var movSrc = video.dataset.videoSrcMov;
            var chosenSrc = null;
            var chosenType = null;

            if (deviceType === 'desktop') {
              if (safari && movSrc) {
                chosenSrc = movSrc;
                chosenType = 'video/quicktime; codecs=hvc1';
              } else if (webmSrc) {
                chosenSrc = webmSrc;
                chosenType = 'video/webm; codecs=vp9, opus';
              } else if (movSrc) {
                chosenSrc = movSrc;
                chosenType = 'video/quicktime; codecs=hvc1';
              }
            } else {
              if (movSrc) {
                chosenSrc = movSrc;
                chosenType = 'video/quicktime; codecs=hvc1';
              } else if (webmSrc) {
                chosenSrc = webmSrc;
                chosenType = 'video/webm; codecs=vp9, opus';
              }
            }

            if (chosenSrc) {
              const source = document.createElement('source');
              source.src = chosenSrc;
              if (chosenType) source.type = chosenType;
              video.appendChild(source);
              video.load();
            }
          }
        });
      }

      // Function to filter images by variant
      function filterImagesByVariant(variantId) {
        if (!variantId) return;

        const imageWrappers = carousel.querySelectorAll('.carousel-image-wrapper');
        const videoWrappers = carousel.querySelectorAll('.carousel-video-wrapper');
        const thumbnails = carousel.querySelectorAll('.carousel-thumbnail[data-media-type="image"]');
        const videoThumbnails = carousel.querySelectorAll('.carousel-thumbnail[data-media-type="video"]');
        const allThumbnails = carousel.querySelectorAll('.carousel-thumbnail');

        console.log('Filtering images for variant:', variantId);
        console.log('Total image wrappers:', imageWrappers.length);
        console.log('Total video wrappers:', videoWrappers.length);
        console.log('Total thumbnails:', thumbnails.length);
        console.log('Total video thumbnails:', videoThumbnails.length);

        // Get variant data including featured image
        const variantMetafields = window.variantMetafields || {};
        const variantData = variantMetafields.variants?.[variantId] || {};
        const variantFeaturedImage = variantData.featured_image || '';

        // Check if the video URLs are valid (not placeholder URLs)
        const isValidVideoUrl = function (url) {
          return url && url !== '' && !url.match(/\/cdn\/shop\/files\/\?/); // Filter out placeholder URLs like //shopspicydan.myshopify.com/cdn/shop/files/?10995
        };

        // Check if variant has valid video metafields
        const hasVideoForVariant = isValidVideoUrl(variantData.animated_video);
        const hasMobileVideoForVariant = isValidVideoUrl(variantData.animated_video_mobile);

        console.log('Variant data:', variantData);
        console.log('Variant featured image:', variantFeaturedImage);
        console.log('Animated video:', variantData.animated_video);
        console.log('Animated video mobile:', variantData.animated_video_mobile);
        console.log('Has video for variant:', hasVideoForVariant);
        console.log('Has mobile video for variant:', hasMobileVideoForVariant);

        // Show/hide video wrappers and thumbnails based on variant
        videoWrappers.forEach(function (wrapper) {
          const deviceType = wrapper.getAttribute('data-device');
          const shouldShowVideo =
            (deviceType === 'desktop' && hasVideoForVariant) || (deviceType === 'mobile' && hasMobileVideoForVariant);
          wrapper.style.display = shouldShowVideo ? '' : 'none';
          console.log('Video wrapper for', deviceType, 'display:', shouldShowVideo ? 'show' : 'hide');
        });

        videoThumbnails.forEach(function (thumbnail) {
          const deviceType = thumbnail.getAttribute('data-device');
          const shouldShowThumb =
            (deviceType === 'desktop' && hasVideoForVariant) || (deviceType === 'mobile' && hasMobileVideoForVariant);
          thumbnail.style.display = shouldShowThumb ? '' : 'none';
          console.log(
            'Video thumbnail for',
            deviceType,
            'hasVideoForVariant:',
            hasVideoForVariant,
            'hasMobileVideoForVariant:',
            hasMobileVideoForVariant,
            'shouldShow:',
            shouldShowThumb,
            'display:',
            shouldShowThumb ? 'show' : 'hide'
          );
        });

        imageWrappers.forEach(function (wrapper) {
          const variantIds = wrapper.getAttribute('data-variant-ids');

          console.log('Image wrapper variant IDs:', variantIds);

          // If image has variant IDs from Liquid, use that logic
          if (variantIds && variantIds !== '') {
            const variantIdArray = variantIds.split(',');
            if (variantIdArray.includes(variantId)) {
              wrapper.style.display = '';
            } else {
              wrapper.style.display = 'none';
            }
            return;
          }

          // If variant has a featured image, try to match by image src
          if (variantFeaturedImage && variantFeaturedImage !== '') {
            const imgElement = wrapper.querySelector('img');
            if (imgElement) {
              const imgSrc = imgElement.src;
              // Extract base URL without query params for comparison
              const imgBaseUrl = imgSrc.split('?')[0].split('&')[0];
              const variantBaseUrl = variantFeaturedImage.split('?')[0].split('&')[0];
              console.log('Comparing image src:', imgBaseUrl, 'with variant:', variantBaseUrl);
              // Check if the image src matches the variant's featured image
              if (
                imgSrc.includes(variantBaseUrl) ||
                variantBaseUrl.includes(imgBaseUrl) ||
                imgBaseUrl.includes(variantBaseUrl.split('/').pop()) ||
                variantBaseUrl.includes(imgBaseUrl.split('/').pop())
              ) {
                console.log('Match found, showing image');
                wrapper.style.display = '';
              } else {
                console.log('No match, hiding image');
                wrapper.style.display = 'none';
              }
            } else {
              wrapper.style.display = '';
            }
          } else {
            // No variant-specific image data, show all images
            wrapper.style.display = '';
          }
        });

        // Hide/show thumbnails accordingly
        // First add visible video thumbnails
        let visibleThumbnails = [];
        videoThumbnails.forEach(function (thumbnail) {
          const displayStyle = thumbnail.style.display;
          const computedDisplay = window.getComputedStyle(thumbnail).display;
          console.log('Video thumbnail display style:', displayStyle, 'computed display:', computedDisplay);
          // Check both inline style and computed style
          if (displayStyle !== 'none' && computedDisplay !== 'none') {
            visibleThumbnails.push(thumbnail);
            console.log('Adding video thumbnail to visible thumbnails');
          } else {
            console.log('Skipping video thumbnail (hidden)');
          }
        });

        // Then add visible image thumbnails
        thumbnails.forEach(function (thumbnail) {
          const variantIds = thumbnail.getAttribute('data-variant-ids');

          console.log('Thumbnail variant IDs:', variantIds);

          // If thumbnail has variant IDs from Liquid, use that logic
          if (variantIds && variantIds !== '') {
            const variantIdArray = variantIds.split(',');
            if (variantIdArray.includes(variantId)) {
              console.log('Thumbnail matches variant by IDs, showing');
              thumbnail.style.display = '';
              visibleThumbnails.push(thumbnail);
            } else {
              console.log('Thumbnail does not match variant by IDs, hiding');
              thumbnail.style.display = 'none';
            }
            return;
          }

          // If variant has a featured image, try to match by image src
          if (variantFeaturedImage && variantFeaturedImage !== '') {
            const imgElement = thumbnail.querySelector('img');
            if (imgElement) {
              const imgSrc = imgElement.src;
              // Extract base URL without query params for comparison
              const imgBaseUrl = imgSrc.split('?')[0].split('&')[0];
              const variantBaseUrl = variantFeaturedImage.split('?')[0].split('&')[0];
              if (
                imgSrc.includes(variantBaseUrl) ||
                variantBaseUrl.includes(imgBaseUrl) ||
                imgBaseUrl.includes(variantBaseUrl.split('/').pop()) ||
                variantBaseUrl.includes(imgBaseUrl.split('/').pop())
              ) {
                console.log('Thumbnail matches variant featured image, showing');
                thumbnail.style.display = '';
                visibleThumbnails.push(thumbnail);
              } else {
                console.log('Thumbnail does not match variant featured image, hiding');
                thumbnail.style.display = 'none';
              }
            } else {
              console.log('Thumbnail has no img element, showing');
              thumbnail.style.display = '';
              visibleThumbnails.push(thumbnail);
            }
          } else {
            console.log('No variant-specific image data, showing for all');
            thumbnail.style.display = '';
            visibleThumbnails.push(thumbnail);
          }
        });

        console.log('Visible thumbnails after filtering:', visibleThumbnails.length);
        visibleThumbnails.forEach(function (thumb, idx) {
          console.log(
            'Visible thumbnail',
            idx,
            'type:',
            thumb.getAttribute('data-media-type'),
            'device:',
            thumb.getAttribute('data-device')
          );
        });

        // Remove active class from all thumbnails and media first
        allThumbnails.forEach(function (thumb) {
          thumb.classList.remove('active');
        });
        imageWrappers.forEach(function (wrapper) {
          wrapper.classList.remove('active');
        });
        videoWrappers.forEach(function (wrapper) {
          wrapper.classList.remove('active');
        });

        // If there are visible thumbnails, determine which media to activate
        if (visibleThumbnails.length > 0) {
          // Check if variant has video - if so, activate video first, otherwise activate image
          const variantMetafields = window.variantMetafields || {};
          const variantData = variantMetafields.variants?.[variantId] || {};
          const hasVideoForVariant = variantData.animated_video && variantData.animated_video !== '';

          // Find video thumbnail if variant has video
          const videoThumbnail = hasVideoForVariant
            ? visibleThumbnails.find(function (thumb) {
                return thumb.getAttribute('data-media-type') === 'video';
              })
            : null;

          // Determine which thumbnail to activate
          const thumbnailToActivate = videoThumbnail || visibleThumbnails[0];
          thumbnailToActivate.classList.add('active');

          const activeMediaIndex = thumbnailToActivate.getAttribute('data-media-index');
          const deviceType = isDesktop() ? 'desktop' : 'mobile';

          // Activate corresponding media wrapper
          if (thumbnailToActivate.getAttribute('data-media-type') === 'video') {
            // Activate video wrapper
            const activeVideo = carousel.querySelector(
              `.carousel-video-wrapper[data-media-index="${activeMediaIndex}"][data-device="${deviceType}"]`
            );
            if (activeVideo) {
              activeVideo.classList.add('active');
              // Make sure video plays
              const video = activeVideo.querySelector('.carousel-main-video');
              if (video && video.querySelector('source')) {
                video.play();
              }
            }
          } else {
            // Activate image wrapper
            const activeImage = carousel.querySelector(
              `.carousel-image-wrapper[data-media-index="${activeMediaIndex}"]`
            );
            if (activeImage && activeImage.style.display !== 'none') {
              activeImage.classList.add('active');
            }
          }
        }
      }

      // Function to get current variant ID from page
      function getCurrentVariantId() {
        const variantInput = document.getElementById('variant-input');
        if (variantInput && variantInput.value) {
          return variantInput.value;
        }
        return null;
      }

      // Initial load
      loadVideosForDevice();

      // Filter images by current variant on page load
      const initialVariantId = getCurrentVariantId();
      if (initialVariantId) {
        filterImagesByVariant(initialVariantId);
      }

      // Handle thumbnail clicks
      thumbnails.forEach(function (thumbnail, index) {
        thumbnail.addEventListener('click', function () {
          // Pause all videos before switching
          pauseAllProductVideos();
          pauseAllAnimatedVideos();

          // Remove active class from all thumbnails and media
          thumbnails.forEach(function (thumb) {
            thumb.classList.remove('active');
          });
          mediaWrappers.forEach(function (wrapper) {
            wrapper.classList.remove('active');
          });

          // Add active class to clicked thumbnail and corresponding media
          this.classList.add('active');
          const mediaIndex = this.getAttribute('data-media-index');
          const mediaType = this.getAttribute('data-media-type');
          const deviceType = isDesktop() ? 'desktop' : 'mobile';

          // Find the appropriate media wrapper
          let targetMedia = null;

          if (mediaType === 'product-video') {
            // Product videos don't have device attribute
            targetMedia = carousel.querySelector(`[data-media-index="${mediaIndex}"][data-media-type="product-video"]`);
          } else if (mediaType === 'video') {
            // Animated videos have device attribute
            targetMedia = carousel.querySelector(`[data-media-index="${mediaIndex}"][data-device="${deviceType}"]`);
          } else {
            // Images don't have device attribute
            targetMedia = carousel.querySelector(`[data-media-index="${mediaIndex}"][data-media-type="image"]`);
          }

          if (targetMedia) {
            targetMedia.classList.add('active');

            // Handle video playback based on type
            if (mediaType === 'product-video' || mediaType === 'video') {
              // Play the video when selected
              const video = targetMedia.querySelector('.carousel-main-video');
              if (video) {
                video.play();
              }
            }
          }
        });

        // Handle keyboard navigation
        thumbnail.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });
      });

      // Handle arrow key navigation
      carousel.addEventListener('keydown', function (e) {
        const activeThumbnail = carousel.querySelector('.carousel-thumbnail.active');
        if (!activeThumbnail) return;

        const currentIndex = Array.from(thumbnails).indexOf(activeThumbnail);
        let newIndex = currentIndex;

        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          newIndex = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          newIndex = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
        }

        if (newIndex !== currentIndex) {
          e.preventDefault();
          thumbnails[newIndex].click();
          thumbnails[newIndex].focus();
        }
      });

      // Make carousel focusable for keyboard navigation
      carousel.setAttribute('tabindex', '0');

      // Handle window resize to switch between mobile/desktop video behavior
      let resizeTimeout;
      let currentDeviceType = isDesktop() ? 'desktop' : 'mobile';

      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          const newDeviceType = isDesktop() ? 'desktop' : 'mobile';

          // Only act if device type actually changed
          if (newDeviceType !== currentDeviceType) {
            currentDeviceType = newDeviceType;

            // Check if we have a video for the new device type
            const deviceVideo = carousel.querySelector(`.carousel-video-wrapper[data-device="${newDeviceType}"]`);
            const deviceThumb = carousel.querySelector(`.carousel-thumbnail[data-device="${newDeviceType}"]`);

            if (deviceVideo) {
              // Switch to appropriate video for new device
              mediaWrappers.forEach(function (wrapper) {
                wrapper.classList.remove('active');
              });
              thumbnails.forEach(function (thumb) {
                thumb.classList.remove('active');
              });

              deviceVideo.classList.add('active');
              if (deviceThumb) {
                deviceThumb.classList.add('active');
              }

              // Load video if not already loaded
              const video = deviceVideo.querySelector('.carousel-main-video');
              if (video && !video.querySelector('source')) {
                const safari = isSafariBrowser();
                var webmSrc = video.dataset.videoSrcWebm;
                var movSrc = video.dataset.videoSrcMov;
                var chosenSrc = null;
                var chosenType = null;
                if (newDeviceType === 'desktop') {
                  if (safari && movSrc) {
                    chosenSrc = movSrc;
                    chosenType = 'video/quicktime; codecs=hvc1';
                  } else if (webmSrc) {
                    chosenSrc = webmSrc;
                    chosenType = 'video/webm; codecs=vp9, opus';
                  } else if (movSrc) {
                    chosenSrc = movSrc;
                    chosenType = 'video/quicktime; codecs=hvc1';
                  }
                } else {
                  if (movSrc) {
                    chosenSrc = movSrc;
                    chosenType = 'video/quicktime; codecs=hvc1';
                  } else if (webmSrc) {
                    chosenSrc = webmSrc;
                    chosenType = 'video/webm; codecs=vp9, opus';
                  }
                }
                if (chosenSrc) {
                  const source = document.createElement('source');
                  source.src = chosenSrc;
                  if (chosenType) source.type = chosenType;
                  video.appendChild(source);
                  video.load();
                  video.play();
                }
              }
            } else if (imageWrappers.length > 0) {
              // No video for this device, switch to first image
              mediaWrappers.forEach(function (wrapper) {
                wrapper.classList.remove('active');
              });
              thumbnails.forEach(function (thumb) {
                thumb.classList.remove('active');
              });

              imageWrappers[0].classList.add('active');
              const firstImageThumb = carousel.querySelector('.carousel-thumbnail[data-media-type="image"]');
              if (firstImageThumb) {
                firstImageThumb.classList.add('active');
              }
            }
          }
        }, 250);
      });

      // Store filterImagesByVariant function for this carousel instance
      carousel._filterImagesByVariant = filterImagesByVariant;
    });

    // Global function to filter all carousels by variant ID
    window.filterProductCarouselImages = function (variantId) {
      const carousels = document.querySelectorAll('.product-carousel');
      carousels.forEach(function (carousel) {
        if (carousel._filterImagesByVariant) {
          carousel._filterImagesByVariant(variantId);
        }
      });
    };
  });
  } catch(e) { console.error(e); }
})();

})();
